<template>
  <div class="wrapper">
    <slot name="element">
    </slot>
    <span class="content">
      <slot name="content">
      </slot>
    </span>
  </div>
</template>

<style scoped>
.wrapper
{
  @apply relative inline-block;
  @apply cursor-help;
}

.wrapper
.content
{
  @apply absolute invisible;
  @apply w-80 px-4 py-2 mx-4 z-50;
  @apply rounded-lg bg-gray-200;
  @apply text-sm text-gray-800 text-center;
}

.wrapper:hover
.content
{
  @apply visible !important;
}
</style>
